import { ElementType, ReactNode } from 'react';
import { useAccordion, useAccordionClick } from './AccordionProvider';

type ToggleProps = {
  element: ElementType;
  eventKey: number;
  children: ReactNode;
};

export function Toggle({ element: Component, eventKey, children, ...otherProps }: ToggleProps): JSX.Element {
  const accordionClick = useAccordionClick(eventKey);

  return (
    <Component onClick={accordionClick} {...otherProps}>
      {children}
    </Component>
  );
}

type CollapseProps = {
  element: ElementType;
  eventKey: string | number;
  children?: ReactNode;
};

export function Collapse({ element: Component, eventKey, children, ...otherProps }: CollapseProps): JSX.Element | null {
  const { activeEventKey } = useAccordion();
  const expanded = activeEventKey === eventKey;

  return activeEventKey === eventKey ? (
    <Component {...otherProps} expanded={expanded}>
      {children}
    </Component>
  ) : null;
}

Collapse.defaultProps = {
  children: null,
};
